// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--3wcqw";